'use strict';

/**
 * Service: Status
 *
 * @version
 * 12.4.0 #756 MLIBJS-121 Add validation to export wdStatusService for ES6 usage
 * 12.2.0 #748 MLIBJS-115 Add method to wdStatusService to allow setting the fulfillment status
 * 9.0.0 #701 MLIBJS-75 Remove deprecated services
 * 7.4.0 #470 Refactor changes to status and fulfilment group statuses
 * 7.3.0 #458 Refactor wdFulfillment, wdStatus (inject helpers)
 * 7.1.1 #441 Missing icon on custom production statuses
 * 7.0.0 #433 Adapt Main Library for Custom Statuses
 * 5.9.0 #399 Add getRowClassByStatus \
 * 5.9.0 #398 Implement new Production Statuses
 * 5.9.0 #397 Refactor based on API standardisation
 * 5.9.0 #396 Adapt wdStatusService to allow for calendar type separation
 * 5.0.1 #286 Standardise Data Loading and Parsing Services
 *
 * @author Dallas Vogels <dvogels@webduct.com>
 * @author Deitric Jang <djang@webduct.com>
 * @author Erik Orozco <eorozco@intersog.com>
 *
 * @copyright (c) 2014-2020 Build Centrix
 */
var wdStatusService = angular.module('wd.service.status', [])
    .factory(
        'wdStatusService',
        [
            'wdOauth2HttpService', '$q', 'wdApiResponseHandler', 'wdOrderStatusHelper',
            function (wdOauth2HttpService, $q, wdApiResponseHandler, wdOrderStatusHelper) {
                // Initialize Service
                var service = {};

                // Initialize Data Storage
                service.statuses = [];
                service.deliveryStatuses = [];

                // Variables
                var apiUrl;     // e.g. timecard-api, ordering-api

                /**
                 * Get the Delivery Icon to be used based on Status
                 *
                 * @since 7.0.0
                 *
                 * @param {number} status 
                 * @returns {string}
                 */
                service.getDeliveryIconByStatus = function (status) {
                    return wdOrderStatusHelper.getDeliveryIconByStatus(status);
                };

                /**
                 * Get the Icon to be used based on Status
                 *
                 * @since 5.0.1
                 * 
                 * @param {number} status
                 * @returns {string}
                 */
                service.getIconByStatus = function (status) {
                    return wdOrderStatusHelper.getIconByStatus(status);
                };

                /**
                 * Get Delivery Status Details
                 *
                 * @since 5.9.0
                 * @param {number} val
                 * @returns {object}
                 */
                service.getDeliveryStatusDetails = function (val) {
                    return wdOrderStatusHelper.getDeliveryStatusDetails(val);
                };

                /**
                 * Get Status Details
                 *
                 * @since 1.0.0
                 * 
                 * @params {number} val
                 * @returns {object} statusDetails
                 */
                service.getStatusDetails = function (val) {
                    return wdOrderStatusHelper.getStatusDetails(val);
                };

                /**
                 * Get Delivery Statuses
                 *
                 * @since 5.9.0
                 * @returns {promise}
                 */
                service.getDeliveryStatuses = function () {

                    var deferred = $q.defer();

                    //Clear Current Values
                    service.deliveryStatuses = [];

                    var url = apiUrl + 'orders/delivery/statuses';

                    wdOauth2HttpService.get(url)
                        .then(
                            function (response) {
                                if (wdApiResponseHandler.isGoodResponseCode(response.status)) {

                                    service.deliveryStatuses = response.data ? service.parseDeliveryStatuses(response.data) : [];
                                    deferred.resolve(response);

                                } else {

                                    deferred.reject(response);

                                }

                            }, function (response) {

                                deferred.reject(response);

                            });

                    return deferred.promise;
                };

                /**
                 * Get Statuses
                 *
                 * @deprecated It is recommended to fetch the fulfillment statuses with GraphQL instead of the rest api
                 * @see https://webduct.atlassian.net/browse/TIMUI-241
                 *
                 * @since 5.0.1
                 * @returns {object}
                 */
                service.getStatuses = function () {

                    var deferred = $q.defer();

                    //Clear Current Values
                    service.statuses = [];

                    var url = apiUrl + 'orders/fulfillment/statuses';

                    wdOauth2HttpService.get(url)
                        .then(
                            function (response) {
                                if (wdApiResponseHandler.isGoodResponseCode(response.status)) {

                                    service.statuses = response.data ? service.parseStatuses(response.data) : [];
                                    deferred.resolve(response);

                                } else {

                                    deferred.reject(response);

                                }

                            }, function (response) {

                                deferred.reject(response);

                            });

                    return deferred.promise;
                };

                /**
                 * Set fulfillment group statuses
                 *
                 * @since 12.2.0
                 *
                 * @param {Array} statuses
                 * @returns {boolean}
                 */
                service.setStatuses = function (statuses) {

                    if (statuses) {
                        service.statuses = service.parseStatuses(statuses);
                    } else {
                        service.statuses = [];
                    }

                    return true;
                };

                /**
                 * Parse Delivery Statuses
                 *
                 * @since 5.9.0
                 * @param {array} statuses
                 * @returns {array}
                 */
                service.parseDeliveryStatuses = function (statuses) {
                    return wdOrderStatusHelper.parseDeliveryStatuses(statuses);
                };

                /**
                 * Parse Order Statuses
                 *
                 * @since 5.0.1
                 * 
                 * @param {array} statuses
                 * @returns {array}
                 */
                service.parseStatuses = function (statuses) {
                    return wdOrderStatusHelper.parseStatuses(statuses);
                };

                /**
                 * Set Api Url
                 *
                 * @since 7.3.0
                 *
                 * @param {string} url
                 * @returns {boolean}
                 */
                service.setApiUrl = function (url) {

                    apiUrl = url;
                    return true;

                };

                return service;
            }
        ]
    );
if (typeof module !== 'undefined' && module.exports) {
    module.exports = wdStatusService;
}
// EOF
